import {
    graphql
} from 'react-relay'


const query = graphql`
    query getAllHtmlTemplateQuery ($pagination: PaginationInput, $sorts: [OrderInput!], $where: JSON) {
        getAllHtmlTemplate (pagination: $pagination, sorts: $sorts, where: $where) {
            count,
            items {
                id
                name
                tpl
                categoryTemplateId
                isDefault
                categoryTemplate{id, name, code}
                createdAt
                updatedAt
            }
      }
    }
  `

  export default query;